import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Input } from 'formik-antd';
import { FormInput, Box } from 'atoms';

const { Title } = Typography;

export function LRReference({ isEditMode }) {
	return (
		<Box padding="1rem">
			<div style={{ textAlign: 'center' }}>
				<Title level={4}>Reference</Title>
			</div>
			<Row>
				<Col span={24}>
					<FormInput name="client_reference_number" label="Client Reference Number">
						<Input
							name="client_reference_number"
							placeholder="Reference Number"
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<FormInput name="ewb_number" label="EWay Bill No.">
						<Input
							name="ewb_number"
							placeholder="EWay Bill No."
							controls={false}
							style={{ width: '100%' }}
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
			</Row>
		</Box>
	);
}

LRReference.propTypes = {
	isEditMode: PropTypes.bool,
};
